'use client'

import { parseAsBoolean, useQueryState } from 'nuqs'
import { DialogTitle } from '@headlessui/react'
import RoundedButton from '@/shared/components/buttons/rounded-button'
import { DialogModal } from '@/shared/components/DialogModal'
import React from 'react'

export default function PopupModals() {
  const [showPaymentUpdateSuccessModal, setShowPaymentUpdateSuccessModal] =
    useQueryState(
      'pupds',
      parseAsBoolean.withDefault(false).withOptions({
        clearOnDefault: true,
        history: 'push',
      }),
    )

  return (
    <>
      <DialogModal
        motionPreset="editorial"
        onClose={() => setShowPaymentUpdateSuccessModal(false)}
        panelClasses="!rounded-[20px] !shadow-none"
        show={showPaymentUpdateSuccessModal}
      >
        <div className="px-2 py-4">
          <div>
            <div className="text-left">
              <DialogTitle
                as="h3"
                className="text-lg font-semibold text-gray-900"
              >
                Payment Method Updated
              </DialogTitle>
              <div className="mt-4 text-sm text-gray-600">
                <p className="text-base text-gray-600">
                  Your new payment details have been saved for all future
                  orders.
                </p>
              </div>
            </div>
          </div>
          <div className="mt-6 flex flex-col gap-y-1.5 sm:mt-8">
            <RoundedButton
              color="black"
              onClick={() => setShowPaymentUpdateSuccessModal(false)}
            >
              Close
            </RoundedButton>
          </div>
        </div>
      </DialogModal>
    </>
  )
}
